<template>
  <div></div>
</template>

<script>
import { config } from '@/config'
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  data () {
    return {
    }
  },
  methods: {
    ...mapActions(['clearAllState']),
    init () {
      this.clearAllState()
      localStorage.removeItem(config.localStorageKey.login)

      const localKeyForBypass = config.localStorageKey.geoBanBypass
      if (localStorage.getItem(localKeyForBypass)) {
        localStorage.removeItem(localKeyForBypass)
      }

      this.$router.push({ name: config.defaultRedirect.publicHome })
    }
  },
  created () {
    this.init()
  }
}
</script>
